/* React */
import React from "react";

/* React-Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { collapseGroupedNodes } from "src/redux/features/insights-options/treatment-patterns/sankey-diagram/sankeyDiagramOptionsSlice";

/* Ionic */
import { chevronCollapse, search } from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./SankeyDiagramOptions.module.scss";

const SankeyDiagramOptions: React.FC = () => {
  const dispatch = useDispatch();

  const sankeyDiagramOptionsState = useSelector(
    (state: RootState) => state.sankeyDiagramOptions
  );

  const { expandedOthers, expandedGroups } = sankeyDiagramOptionsState;

  return (
    <div className={styles.sankey_diagram_options}>
      <PrimaryFabButton
        className={"small primary"}
        ariaLabel={"Expand"}
        icon={chevronCollapse}
        disabled={expandedOthers.length === 0 && expandedGroups.length === 0}
        onClick={() => {
          dispatch(collapseGroupedNodes());
        }}
      />
      <PrimaryFabButton
        className={"small primary"}
        ariaLabel={"Expand"}
        icon={search}
        disabled={true}
        onClick={() => {
          console.log("Not implemented yet");
        }}
      />
    </div>
  );
};

export default SankeyDiagramOptions;
